// removed by extract-text-webpack-plugin
module.exports = {"categories":"Categories__categories___2ntIe","categoriesItem":"Categories__categoriesItem___1-sKK"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/signUpMarketing2/components/Categories.scss
// module id = 1801
// module chunks = 0